import { render, staticRenderFns } from "./FamilyBackgroundPrint.vue?vue&type=template&id=6b338347&"
import script from "./FamilyBackgroundPrint.vue?vue&type=script&lang=js&"
export * from "./FamilyBackgroundPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports